import { ICMSTextV2Props } from '../Text/TextV2'
import { ITextBlockListProps } from '../TextBlockList/TextBlockList'
import { IActionButton } from '../ActionButton/ActionButton'
import { IStoryCardListProps } from '../StoryCardList/StoryCardList'
import { IBillboardImageProps } from '../BillboardWithImage/BillboardImage'

export enum ComponentType {
  Text,
  TextBlockList,
  ActionButton,
  StoryCardList,
  BillboardImage,
}

export interface IBaseIComponent {
  type: ComponentType
  props: ICMSTextV2Props | ITextBlockListProps | IActionButton | IStoryCardListProps | IBillboardImageComponent
}

export interface ITextComponent extends IBaseIComponent {
  type: ComponentType.Text
  props: ICMSTextV2Props
}

export interface ITextBlockListComponent extends IBaseIComponent {
  type: ComponentType.TextBlockList
  props: ITextBlockListProps
}

export interface IActionButtonComponent extends IBaseIComponent {
  type: ComponentType.ActionButton
  props: IActionButton
}

export interface IStoryCardListComponent extends IBaseIComponent {
  type: ComponentType.StoryCardList
  props: IStoryCardListProps
}

export interface IBillboardImageComponent extends IBaseIComponent {
  type: ComponentType.BillboardImage
  props: IBillboardImageProps
}
